const mutations = {
    clear: (state, customer) => state.customer = customer,
    setAutenticaco: (state, autenticacao) => state.autenticacao = autenticacao,
    setCentroCusto: (state, centroCusto) => state.centroCusto = centroCusto,
    setCliente: (state, cliente) => state.cliente = cliente,
    setCustomer: (state, customer) => state.customer = customer,
    setExportacaoEsusEmAndamento: (state, value) => state.exportacaoEsusEmAndamento = value,
    setFila: (state, params) => state.fila = params,
    setLoading: (state) => state.loading++,
    setLotacao: (state, lotacao) => state.lotacao = lotacao,
    setMenu: (state, menu) => state.menu = menu,
    setQuantidadeNotasVersaoNovas: (state, value) => state.quantidadeNotasVersaoNovas = value,
    setQuantidadeNotificacoesNaoLidas: (state, value) => state.quantidadeNotificacoesNaoLidas = value,
    setRouterInfo: (state, value) => state.routerInfo = value,
    setShowExitFormConfirmation: (state) => state.showExitFormConfirmation = true,
    setSidebar: (state, value) => state.sidebar = value,
    unsetLoading: (state) => state.loading--,
    unsetShowExitFormConfirmation: (state) => state.showExitFormConfirmation = false,
}

export default mutations